import { render, staticRenderFns } from "./BoardsStore.vue?vue&type=template&id=6316e5ad&"
import script from "./BoardsStore.vue?vue&type=script&lang=js&"
export * from "./BoardsStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports